import { ActionIcon, type ActionIconProps } from '@mantine/core';
import type { CSSProperties } from 'react';

type IconButtonProps = Omit<ActionIconProps, 'variant' | 'style'> & {
  onClick?: () => void;
  style?: CSSProperties;
  children: React.ReactNode;
};

export function IconButton({ style, children, ...props }: IconButtonProps) {
  return (
    <ActionIcon variant="transparent" {...props} style={{ borderRadius: 20, ...style }}>
      {children}
    </ActionIcon>
  );
}
